module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMA8MB/MOBgQBCwcNDPIKCQj2Q/M5OksQAAAIxJREFUGNOl0NsOwyAIBmBOHmq13cb7v+twaNt4u/+CyBdIDOCRDyxJm1pqyTdlI0+QC8m6TrsqtmHRWi+sSgP78qt6IcpzewSZSZHiE/GN/qgCwAOLm9WQIXsTNvOkmqIqA8hPjz7Vx9D/kDqyzjjGUPg49xvZUPwAl+HjBnGaLMcy0hOWSINW4N98AYhSDGv1JOT0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wei-xin.png
// module id = cAR4
// module chunks = 21